import { getIn } from 'formik'

import type {
	FormikValues,
	QuestionDefinition,
	UploadedFileMetadata,
} from '../../types'

import { budgetApiClient } from '../../../../api/budgetApiClient'

export type DocumentUploads = Record<string, UploadedFileMetadata[]>

export const uploadDocuments = async (
	values: FormikValues,
	questions: QuestionDefinition[],
): Promise<DocumentUploads> => {
	const documentQuestions = questions.filter(
		(q) => q.questionType === 'documentUpload',
	)

	const entries = await Promise.all(
		documentQuestions
			.filter((question) => {
				const answer = getIn(values, question.formFieldKey)
				return Array.isArray(answer) && answer.length > 0
			})
			.map(async (question) => {
				const files = getIn(values, question.formFieldKey) as File[]
				const uploaded = await budgetApiClient.uploadFiles(files)
				return [
					question.formFieldKey,
					uploaded as UploadedFileMetadata[],
				] as const
			}),
	)

	return Object.fromEntries(entries)
}
